
import store from "@/store";
import { defineComponent } from "vue";
import LoginFormComponent from "@/components/authComponents/LoginForm.vue";

export default defineComponent({
  name: "Authentication_Page",

  components: { LoginFormComponent },

  computed: {
    authenticationStatus(): string {
      return store.getters["auth/getAuthenticationStatus"];
    },
  },
});
